import React from 'react';
import {FormattedMessage} from 'react-intl';
import {usePaymentPaypalContext} from '../../contexts/PaymentPaypalContext';
import styles from './PaypalLink.module.scss';
import ButtonAction from '../../../../common/components/ui/ButtonAction';

const PaypalLink = () => {
  const {paypalLink, goToPaypal} = usePaymentPaypalContext();

  return Boolean(paypalLink)
    ? (
      <ButtonAction
        variant={'link'}
        type={'button'}
        label={
          <FormattedMessage
            id={'payment-paypal-link'}
            defaultMessage={'Go to PayPal'}
          />
        }
        customClassnames={{
          container: styles.paymentLinkContainer,
          label: styles.paymentLinkLabel
        }}
        onClick={goToPaypal}
      />
    )
    : null;
};

export default PaypalLink;
